// Label Bahasa Indonesia untuk kode dari API.
export const CLASS_LABEL: Record<string, string> = { GENERAL: 'General', PNM: 'PNM', SHOPPER: 'Shopper' };

export const COMPONENT_LABEL: Record<string, string> = {
  CASHBACK: 'Cashback',
  ADDITIONAL_CASHBACK: 'Cashback tambahan',
  DIRECT_NON_MEMBER: 'Insentif direct (non-member)',
  DIRECT_RECRUITEE: 'Insentif direct',
  INDIRECT_RECRUITEE: 'Insentif indirect',
  MEMBERSHIP_DIRECT: 'Membership commission (direct)',
  MEMBERSHIP_INDIRECT: 'Membership commission (indirect)',
};

export const ORDER_STATUS_LABEL: Record<string, string> = {
  PENDING: 'Menunggu',
  COMPLETED: 'Selesai',
  CANCELLED: 'Dibatalkan',
  RETURNED: 'Diretur',
};

export const ENTRY_STATUS_LABEL: Record<string, string> = {
  PENDING: 'Tertampung',
  RELEASED: 'Masuk redeem',
  VOID: 'Batal',
  EXPIRED: 'Hangus',
  REINSTATED: 'Dipulihkan',
};

export const TREE_STATUS_LABEL: Record<string, string> = {
  PENDING_PAYMENT: 'Menunggu pembayaran',
  ACTIVE: 'Aktif',
  SUSPENDED: 'Ditangguhkan',
};

export const PACKAGE_STATUS_LABEL: Record<string, string> = {
  PENDING: 'Menunggu pembayaran',
  PAID: 'Lunas',
  EXPIRED: 'Kedaluwarsa',
  FAILED: 'Gagal',
};

export const WITHDRAWAL_STATUS_LABEL: Record<string, string> = {
  REQUESTED: 'Diajukan',
  PROCESSING: 'Diproses',
  SUCCESS: 'Berhasil',
  FAILED: 'Gagal',
};

export const BANK_STATUS_LABEL: Record<string, string> = {
  PENDING_INQUIRY: 'Sedang dicek',
  VERIFIED: 'Terverifikasi',
  REJECTED: 'Ditolak',
  DISABLED: 'Nonaktif',
};

/** Mutasi ledger: jenis transaksi → label + status dana (PRD 12.6). */
export const TXN_LABEL: Record<string, { label: string; status?: string }> = {
  INCENTIVE_PENDING: { label: 'Insentif tercatat', status: 'PENDING' },
  INCENTIVE_RELEASE: { label: 'Insentif cair ke redeem', status: 'RELEASED' },
  INCENTIVE_VOID: { label: 'Insentif batal', status: 'VOID' },
  INCENTIVE_EXPIRE: { label: 'Insentif hangus', status: 'EXPIRED' },
  INCENTIVE_REINSTATE: { label: 'Insentif dipulihkan', status: 'REINSTATED' },
  INCENTIVE_CORRECTION: { label: 'Koreksi insentif' },
  MEMBERSHIP_COMMISSION: { label: 'Membership commission', status: 'RELEASED' },
  WITHDRAWAL_HOLD: { label: 'Pencairan diajukan' },
  WITHDRAWAL_SETTLE: { label: 'Pencairan berhasil' },
  WITHDRAWAL_RELEASE: { label: 'Pencairan gagal, dana kembali' },
  MANUAL_ADJUSTMENT: { label: 'Penyesuaian admin' },
};

export const WALLET_LABEL: Record<string, string> = {
  PENDING: 'Tampungan',
  REDEEM: 'Redeem',
  LOCKED: 'Dalam pencairan',
};

export const PACKAGE_KIND_LABEL: Record<string, string> = {
  ACTIVATION: 'Aktivasi pohon',
  UPGRADE: 'Upgrade kelas',
};
